export enum PremiumStatus {
    Confirmed = "CONFIRMED",
    Pending = "PENDING",
    Refused = "REFUSED",
    None = "NONE"
}

export enum RefusalReasons {
    EstimatesTooLow = "ESTIMATES_TOO_LOW",
    MediaQuality = "MEDIA_QUALITY",
    DescriptionQuality = "DESCRIPTION_QUALITY",
    BadCategory = "BAD_CATEGORY",
    Other = "OTHER"
}

export enum FileAccept {
    Image = "image/jpeg, image/png",
    PDF = "application/pdf",
    CSV = ".csv",
    PV2 = ".zip, .xml"
}
